<script setup lang="ts">
const { ruleset, selected = false } = defineProps({
    ruleset: Object,
    // Ringed in blue when the participant has picked this table in the inter-phase vote.
    selected: Boolean,
})
</script>

<template>
    <!-- The look (pink header, white cells, rounded frame) is the global `.ruleset-table` rule
         in app.css, shared with the tables typed into the instructions copy so both match. -->
    <table v-if="ruleset" class="ruleset-table" :class="{ 'is-selected': selected }">
        <thead>
            <tr>
                <th>TU scegli</th>
                <th>L'ALTRO sceglie</th>
                <th>TU guadagni</th>
                <th>L'ALTRO guadagna</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="combo in [['A','A'],['A','B'],['B','A'],['B','B']]">
                <td>{{ combo[0] }}</td>
                <td>{{ combo[1] }}</td>
                <td>{{ ruleset[combo[0]][combo[1]] }}</td>
                <td>{{ ruleset[combo[1]][combo[0]] }}</td>
            </tr>
        </tbody>
    </table>
</template>

<style scoped>
@reference 'tailwindcss';
@reference '#app.css';

/* The outline takes no layout space, so picking a table doesn't shift the pair. Its corners
   stay square: browsers don't round an outline drawn on a table box. */
.is-selected {
    outline: 2px solid var(--color-blue);
    outline-offset: 10px;
}
</style>
